const TAKE_DESK = 'TAKE_DESK';

export {TAKE_DESK};
